var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueScale = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.1645L7.57555 5H7.58219L7.59292 5.01696L22.463 5.00213L22.4643 5H22.471L27 12.1645C27 14.5463 24.9546 16.4871 22.4444 16.4871C19.9342 16.4871 17.8888 14.5463 17.8888 12.1645L21.5207 6.47756L15.777 6.48329V19.2498L21.1494 25H8.85718L14.223 19.2897V6.48483L8.52443 6.49052L12.1112 12.1645C12.1112 14.5463 10.0659 16.4871 7.55563 16.4871C5.04539 16.4871 3 14.5463 3 12.1645ZM9.35529 10.69L7.5689 7.86075H7.56227L5.75596 10.69H9.35529ZM4.55397 12.1708C4.55397 13.7398 5.89541 15.0126 7.54898 15.0126H7.55563C9.20255 15.0126 10.5507 13.7398 10.5507 12.1708H4.55397ZM22.4577 7.86075L24.2441 10.69H20.6447L22.451 7.86075H22.4577ZM22.4378 15.0126C20.7842 15.0126 19.4427 13.7398 19.4427 12.1708H25.4394C25.4394 13.7398 24.0913 15.0126 22.4444 15.0126H22.4378ZM12.3303 23.5255H17.6961L15.0199 20.6648L12.3303 23.5255Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueScale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlueScale.30041109646ba1e73eb0934d99802bae.svg";